import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {UIChart} from 'primeng/chart';
import {ScoreBarComponent} from '../../../score-bar/score-bar.component';
import {ProviderScoreDisplay} from './provider-score-cell.types';

@Component({
  selector: 'app-provider-score-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, UIChart, ScoreBarComponent],
  templateUrl: './provider-score-cell.component.html',
})
export class ProviderScoreCellComponent {
  readonly value = input.required<number>();
  readonly percentage = input.required<number>();
  readonly display = input<ProviderScoreDisplay>('pie');
  readonly chartData = input<object | null>(null);
  readonly chartOptions = input<object>({});
  readonly wideChart = input(false);
}
